import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { PurchaseOrderDetailsContext, PurchaseOrderDetailsValues } from '../../contexts/PurchaseOrderDetailsContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

export const PurchaseOrderDetailsCopyConfirmModal = () => {
  const { copyOrderQuantities, showCopyModal, closeConfirmModal } = useContext(PurchaseOrderDetailsContext) as PurchaseOrderDetailsValues;
  const { t } = useTranslation('purchaseOrderDetails');

  return (
    <Dialog onClose={closeConfirmModal}
      open={showCopyModal}>
      <DialogTitle>
        {t('confirmCopyModal.title')}
      </DialogTitle>
      <IconButton
        onClick={closeConfirmModal}
        sx={{
          position: 'absolute',
          right: 16,
          top: 8,
          color: (theme) => theme.palette.custom.gray[800],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <Typography>
          {t('confirmCopyModal.body')}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ m: 4 }}>
        <Button variant='secondary'
          size="lg"
          onClick={closeConfirmModal}>
          {t('confirmCopyModal.cancel')}
        </Button>
        <Button variant='primary'
          size="lg"
          onClick={copyOrderQuantities}>
          {t('confirmCopyModal.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};